// src/data/doubts.js

export const doubtsData = [
    {
        id: 1,
        question: "O que é o ÌMÒLAB?",
        answer: "O ÌMÒLAB é um laboratório de inovação e tecnologia vinculado à Universidade Federal da Bahia (UFBA). Nosso objetivo é promover a inovação, o desenvolvimento tecnológico e a pesquisa aplicada, oferecendo um ambiente colaborativo para estudantes, pesquisadores e profissionais de diversas áreas."
    },
    {
        id: 2,
        question: "Como fazer parte do ÌMÒLAB?",
        answer: "Para fazer parte do ÌMÒLAB, você pode se inscrever em nossos programas de pesquisa, participar de eventos e workshops ou entrar em contato conosco através do nosso site ou redes sociais. Estamos sempre abertos a novas parcerias e colaborações."
    },
    {
        id: 3,
        question: "Como são as atividades?",
        answer: "As atividades no ÌMÒLAB incluem projetos de pesquisa, desenvolvimento de protótipos, workshops, palestras e eventos de networking. Trabalhamos em um ambiente colaborativo onde incentivamos a troca de ideias e o aprendizado contínuo."
    },
    {
        id: 4,
        question: "Preciso ser de qual curso para fazer parte?",
        answer: "O ÌMÒLAB é interdisciplinar e aberto a estudantes, pesquisadores e profissionais de todas as áreas do conhecimento. Valorizamos a diversidade de perspectivas e habilidades, pois acreditamos que isso enriquece nossos projetos e iniciativas."
    },
    {
        id: 5,
        question: "Como posso apoiar?",
        answer: "Você pode apoiar o ÌMÒLAB através de parcerias institucionais, doações, voluntariado ou participando de nossos eventos. Entre em contato conosco para saber mais sobre as formas de colaboração e apoio."
    }
];